import i18n from "../i18n"
import {useTranslation} from "react-i18next"

export const useUiLanguage = () => useTranslation().i18n.resolvedLanguage || "ru"

export const translateUi = (source: string, language?: string) => String(i18n.t(source, {
    ns: "ui",
    keySeparator: false,
    defaultValue: source,
    ...(language ? {lng: language} : {})
}))

const translateUiPart = (source: string, language?: string) => {
    const leading = source.match(/^\s*/)?.[0] || ""
    const trailing = source.match(/\s*$/)?.[0] || ""
    const text = source.trim().replace(/\s+/g, " ")
    return text ? `${leading}${translateUi(text, language)}${trailing}` : source
}

export const translateUiParts = (parts: readonly string[], values: readonly unknown[], language?: string) =>
    parts.reduce((result, part, index) => `${result}${translateUiPart(part, language)}${index < values.length ? String(values[index] ?? "") : ""}`, "")
